import CRClassicChallenge from "../../assets/game-mode-icons/clash_royale_classic_challenge.png"
import CRMegaDraftChallenge from "../../assets/game-mode-icons/clash_royale_mega_draft_challenge.png"
import CRPathOfLegends from "../../assets/game-mode-icons/clash_royale_path_of_legends.png"
import CRTrophyRoad from "../../assets/game-mode-icons/clash_royale_trophy_road.png"
import WzBattleRoyale from "../../assets/game-mode-icons/warzone-battle-royale.png"
import WzResurgence from "../../assets/game-mode-icons/warzone-resurgence.png"
import WzResurgenceNew from "../../assets/game-mode-icons/warzone-resurgence-new.png"
import WzResurgenceRanked from "../../assets/game-mode-icons/warzone-resurgence-ranked.png"
import WzResurgenceCasual from "../../assets/game-mode-icons/warzone-resurgence-casual.png"
import WzSlayRide from "../../assets/game-mode-icons/warzone-slay-ride.png"
import WZHolidayRush from "../../assets/game-mode-icons/warzone-holiday-rush.png"
import WzBattleRoyaleNew from "../../assets/game-mode-icons/warzone-battle-royale-new.png"
import WzBattleRoyaleCasual from "../../assets/game-mode-icons/warzone-battle-royale-casual.png"
import WzBattleRoyaleRanked from "../../assets/game-mode-icons/warzone-battle-royale-ranked.png"
import CodW3Tdm from "../../assets/game-mode-icons/mw3-team-deathmatch.png"
import CodW3Domination from "../../assets/game-mode-icons/mw3-domination.png"
import CodW3Hardpoint from "../../assets/game-mode-icons/mw3-hardpoint.png"
import CodW3SND from "../../assets/game-mode-icons/mw3-search-and-destroy.png"
import CodW3FFA from "../../assets/game-mode-icons/mw3-free-for-all.png"
import CodW3GunGame from "../../assets/game-mode-icons/mw3-gungame.png"
import CodW3Ranked from "../../assets/game-mode-icons/mw3-ranked.png"
import CodBo6Tdm from "../../assets/game-mode-icons/codbo6-team-deathmatch.png"
import CodBo6Hardpoint from "../../assets/game-mode-icons/codbo6-hardpoint.png"
import CodBo6Domination from "../../assets/game-mode-icons/codbo6-domination.png"
import CodBo6Control from "../../assets/game-mode-icons/codbo6-control.png"
import CodBo6Faceoff from "../../assets/game-mode-icons/codbo6-faceoff.png"
import CodBo6FreeForAll from "../../assets/game-mode-icons/codbo6-free-for-all.png"
import CodBo6Gunfight from "../../assets/game-mode-icons/codbo6-gun-fight.png"
import CodBo6Headquarters from "../../assets/game-mode-icons/codbo6-headquarters.png"
import CodBo6KillConfirmed from "../../assets/game-mode-icons/codbo6-kill-confirmed.png"
import CodBo6KillOrder from "../../assets/game-mode-icons/codbo6-killorder.png"
import CodBo6SearchAndDestroy from "../../assets/game-mode-icons/codbo6-search-and-destroy.png"
import RLCompetitive from "../../assets/game-mode-icons/rocket-league-competitive.png"
import RLUnranked from "../../assets/game-mode-icons/rock-league-unranked.png"
import Nba2kMyteamShowdown from "../../assets/game-mode-icons/nba2k-myteam-showdown.png"
import Nba2kMyteamKingOfTheCourt from "../../assets/game-mode-icons/nba2k-my-team-king-of-the-court.png"
import Nba2kParkProvingGrounds from "../../assets/game-mode-icons/nba2k-park-proving-grounds.png"
import Nba2kPlaynowRanked from "../../assets/game-mode-icons/nba2k-playnow-ranked.png"
import CFBRoadToCFBRegsRanked from "../../assets/game-mode-icons/cfb-regs-ranked.png"
import CFBCutRankedSeasons from "../../assets/game-mode-icons/cfb-cut-ranked-seasons.png"
import CFBCutChamps from "../../assets/game-mode-icons/cfb-cut-champs.png"
import CFBCutGauntlet from "../../assets/game-mode-icons/cfb-cut-gauntlet.png"
import CFBHouseRules from "../../assets/game-mode-icons/cfb-house-rules-college-ot.png"
import EAFCRankedSeasons from "../../assets/game-mode-icons/eafc-ranked-seasons.png"
import EAFCDivisionRivals from "../../assets/game-mode-icons/eafc-fut-division-rivals.png"
import EAFCFutChamps from "../../assets/game-mode-icons/eafc-fut-champs.png"
import MaddenRegsRanked from "../../assets/game-mode-icons/madden-regs-ranked.png"
import MaddenMutRankedSeason from "../../assets/game-mode-icons/madden-mut-ranked-seasons.png"
import MaddenMutChamps from "../../assets/game-mode-icons/madden-mut-champs.png"
import MaddenMutGauntlet from "../../assets/game-mode-icons/madden-mut-gauntlet.png"
import MaddenHouseRules from "../../assets/game-mode-icons/madden-house-rules-college-ot.png"
import ApexRanked from "../../assets/game-mode-icons/apex-ranked.png"
import ApexUnranked from "../../assets/game-mode-icons/apex-unranked.png"
import FNZeroBuild from "../../assets/game-mode-icons/fn-zero-build.png"
import FNOgZeroBuild from "../../assets/game-mode-icons/fn-og-zb.png"
import FNZeroBuildRanked from "../../assets/game-mode-icons/fn-zb-ranked.png"
import FNOgBuild from "../../assets/game-mode-icons/fn-og.png"
import FNReloadBuild from "../../assets/game-mode-icons/fn-reload.png"
import FNReloadZeroBuild from "../../assets/game-mode-icons/fn-reload-zb.png"
import FNReloadZeroBuildRanked from "../../assets/game-mode-icons/fn-reload-zb-ranked.png"
import FNReloadBuildRanked from "../../assets/game-mode-icons/fn-reload-ranked.png"
import FNBr from "../../assets/game-mode-icons/fn-br.png"
import FNBrRanked from "../../assets/game-mode-icons/fn-br-ranked.png"
import Bf6Breakthrough from "../../assets/game-mode-icons/battlefield6-breakthrough.png"
import Bf6Conquest from "../../assets/game-mode-icons/battlefield6-conquest.png"
import Bf6Domination from "../../assets/game-mode-icons/battlefield6-domination.png"
import Bf6Escalation from "../../assets/game-mode-icons/battlefield6-escalation.png"
import Bf6Koth from "../../assets/game-mode-icons/battlefield6-kingofthehill.png"
import Bf6Payload from "../../assets/game-mode-icons/battlefield6-payload.png"
import Bf6Rush from "../../assets/game-mode-icons/battlefield6-rush.png"
import Bf6SquadDeathmatch from "../../assets/game-mode-icons/battlefield6-squaddeathmatch.png"
import Bf6Tdm from "../../assets/game-mode-icons/battlefield6-teamdeathmatch.png"
import Bf6Strikepoint from "../../assets/game-mode-icons/battlefield6-strikepoint.png"
import { useState } from "react"
import { GameIcon } from "../game-icon/game-icon"

// ported from plc-app src/lib/design-system/iconography/game-mode-icon.web.tsx, keyed by cms game mode systemId
const gameModeIconMap: Record<string, string> = {
  clash_royale_classic_challenge: CRClassicChallenge,
  clash_royale_mega_draft_challenge: CRMegaDraftChallenge,
  clash_royale_trophy_road: CRTrophyRoad,
  clash_royale_path_of_legends: CRPathOfLegends,
  urzikstan: WzBattleRoyale,
  resurgence: WzResurgence,
  codwz2_battle_royale_casual: WzBattleRoyaleCasual,
  codwz2_battle_royale_ranked: WzBattleRoyaleRanked,
  codwz2_battle_royale: WzBattleRoyaleNew,
  codwz2_resurgence: WzResurgenceNew,
  codwz2_resurgence_ranked: WzResurgenceRanked,
  codwz2_resurgence_casual: WzResurgenceCasual,
  codwz2_resurgence_holiday_rush: WZHolidayRush,
  codwz2_resurgence_slay_ride: WzSlayRide,
  codmw3_tdm: CodW3Tdm,
  codmw3_domination: CodW3Domination,
  codmw3_hardpoint: CodW3Hardpoint,
  codmw3_snd: CodW3SND,
  codmw3_ffa: CodW3FFA,
  codmw3_gun_game: CodW3GunGame,
  codmw3_ranked: CodW3Ranked,
  codbo1_tdm: CodBo6Tdm,
  codbo1_hardpoint: CodBo6Hardpoint,
  codbo1_domination: CodBo6Domination,
  codbo1_control: CodBo6Control,
  codbo1_faceoff: CodBo6Faceoff,
  codbo1_ffa: CodBo6FreeForAll,
  codbo1_gun_game: CodBo6Gunfight,
  codbo1_headquarters: CodBo6Headquarters,
  codbo1_kill_confirmed: CodBo6KillConfirmed,
  codbo1_kill_order: CodBo6KillOrder,
  codbo1_snd: CodBo6SearchAndDestroy,
  codbo2_tdm: CodBo6Tdm,
  codbo2_hardpoint: CodBo6Hardpoint,
  codbo2_domination: CodBo6Domination,
  codbo2_control: CodBo6Control,
  codbo2_faceoff: CodBo6Faceoff,
  codbo2_ffa: CodBo6FreeForAll,
  codbo2_gun_game: CodBo6Gunfight,
  codbo2_headquarters: CodBo6Headquarters,
  codbo2_kill_confirmed: CodBo6KillConfirmed,
  codbo2_kill_order: CodBo6KillOrder,
  codbo2_snd: CodBo6SearchAndDestroy,
  codbo6_tdm: CodBo6Tdm,
  codbo6_hardpoint: CodBo6Hardpoint,
  codbo6_domination: CodBo6Domination,
  codbo6_control: CodBo6Control,
  codbo6_faceoff: CodBo6Faceoff,
  codbo6_ffa: CodBo6FreeForAll,
  codbo6_gun_game: CodBo6Gunfight,
  codbo6_headquarters: CodBo6Headquarters,
  codbo6_kill_confirmed: CodBo6KillConfirmed,
  codbo6_kill_order: CodBo6KillOrder,
  codbo6_snd: CodBo6SearchAndDestroy,
  battlefield6_strikepoint: Bf6Strikepoint,
  battlefield6_payload: Bf6Payload,
  battlefield6_koth: Bf6Koth,
  battlefield6_escalation: Bf6Escalation,
  battlefield6_domination: Bf6Domination,
  battlefield6_squad_deathmatch: Bf6SquadDeathmatch,
  battlefield6_tdm: Bf6Tdm,
  battlefield6_breakthrough: Bf6Breakthrough,
  battlefield6_rush: Bf6Rush,
  battlefield6_conquest: Bf6Conquest,
  rocket_league_competitive: RLCompetitive,
  rocket_league_unranked: RLUnranked,
  nba2k25_myteam_showdown: Nba2kMyteamShowdown,
  nba2k25_myteam_king_of_the_court: Nba2kMyteamKingOfTheCourt,
  nba2k25_park_proving_grounds: Nba2kParkProvingGrounds,
  nba2k25_playnow_ranked: Nba2kPlaynowRanked,
  nba2k26_myteam_showdown: Nba2kMyteamShowdown,
  nba2k26_myteam_king_of_the_court: Nba2kMyteamKingOfTheCourt,
  nba2k26_park_proving_grounds: Nba2kParkProvingGrounds,
  nba2k26_playnow_ranked: Nba2kPlaynowRanked,
  cfb25_road_to_cfp: CFBRoadToCFBRegsRanked,
  cfb25_cut_ranked_seasons: CFBCutRankedSeasons,
  cfb25_cut_champs: CFBCutChamps,
  cfb25_cut_gauntlet: CFBCutGauntlet,
  cfb25_house_rules: CFBHouseRules,
  cfb26_road_to_cfp: CFBRoadToCFBRegsRanked,
  cfb26_cut_ranked_seasons: CFBCutRankedSeasons,
  cfb26_cut_champs: CFBCutChamps,
  cfb26_cut_gauntlet: CFBCutGauntlet,
  cfb26_house_rules: CFBHouseRules,
  eafc25_regs_ranked_seasons: EAFCRankedSeasons,
  eafc25_fut_division_rivals: EAFCDivisionRivals,
  eafc25_fut_champs: EAFCFutChamps,
  eafc26_regs_ranked_seasons: EAFCRankedSeasons,
  eafc26_fut_division_rivals: EAFCDivisionRivals,
  eafc26_fut_champs: EAFCFutChamps,
  madden25_regs_ranked: MaddenRegsRanked,
  madden25_mut_ranked_seasons: MaddenMutRankedSeason,
  madden25_mut_champs: MaddenMutChamps,
  madden25_mut_gauntlet: MaddenMutGauntlet,
  madden25_house_rules: MaddenHouseRules,
  madden26_regs_ranked: MaddenRegsRanked,
  madden26_mut_ranked_seasons: MaddenMutRankedSeason,
  madden26_mut_gauntlet: MaddenMutGauntlet,
  madden26_house_rules: MaddenHouseRules,
  madden27_regs_ranked: MaddenRegsRanked,
  madden27_mut_ranked_seasons: MaddenMutRankedSeason,
  madden27_mut_champs: MaddenMutChamps,
  madden27_mut_gauntlet: MaddenMutGauntlet,
  madden27_house_rules: MaddenHouseRules,
  apex_br_ranked: ApexRanked,
  apex_br_unranked: ApexUnranked,
  apex_br_unranked_solos: ApexUnranked,
  fortnite_zero_build: FNZeroBuild,
  fortnite_zero_build_ranked: FNZeroBuildRanked,
  fortnite_og_zero_build: FNOgZeroBuild,
  fortnite_og_build: FNOgBuild,
  fortnite_reload_build: FNReloadBuild,
  fortnite_reload_zero_build: FNReloadZeroBuild,
  fortnite_reload_zero_build_ranked: FNReloadZeroBuildRanked,
  fortnite_reload_build_ranked: FNReloadBuildRanked,
  fortnite_build: FNBr,
  fortnite_build_ranked: FNBrRanked,
}

type GameModeIconProps = {
  gameMode?: string | null
  game?: string | null
  size?: number
  className?: string
  // show the game icon instead of nothing when the mode has no artwork, like plc-app does
  fallbackToGameIcon?: boolean
}

// renders nothing (or the game icon) when a mode has no artwork or its image fails to load
export const GameModeIcon = ({ gameMode, game, size = 24, className, fallbackToGameIcon = false }: GameModeIconProps) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const src = gameMode ? gameModeIconMap[gameMode] : undefined

  if (!src || src === failedSrc) return fallbackToGameIcon ? <GameIcon systemId={game} size={size} /> : null

  return (
    <img
      src={src}
      alt=""
      className={className}
      width={size}
      height={size}
      style={{ objectFit: 'contain', flexShrink: 0 }}
      onError={() => setFailedSrc(src)}
    />
  )
}
